
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'GDMWhite',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/GDMWhite.vue